import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '@rp/environments';
import { AdvertisersResponse } from '@rp/shared/models';

import { AdvertisersProvider } from './advertisers.provider';

@Injectable()
export class HttpAdvertisersProvider implements AdvertisersProvider {
  private _baseUrl = `${environment.apiConfig.adminApiHost}/admin/users`;

  private readonly _httpClient = inject(HttpClient);

  getAdvertisers(params?: string): Observable<AdvertisersResponse> {
    return this._httpClient.get<AdvertisersResponse>(
      `${this._baseUrl}/advertisers/?${params || ''}`,
    );
  }
}
